import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './auth/components/login/login.component';
import { RegisterComponent } from './auth/components/register/register.component';
import { SpanishRoutes } from './common/routes/spanish-routes';
import { EnglishRoutes } from './common/routes/english-routes';
import { FrenchRoutes } from './common/routes/french-routes';
import { PortugueseRoutes } from './common/routes/portuguese-routes';
import { routingGuard } from './common/guards/routing.guard';
import { ErrorComponent } from './common/components/error/error.component';
import { ContactComponent } from './common/components/contact/contact.component';
import { PlatformComponent } from './platform/components/platform/platform.component';

const mergeRoutes = (routesObjects, urlKey, component, canActivate = []) => {
  return routesObjects.flatMap((routesObject) => [
    {
      path: routesObject[urlKey].URL,
      component: component,
      canActivate: canActivate,
    },
    {
      path: `${routesObject[urlKey].URL}?*`,
      component: component,
      canActivate: canActivate,
    },
  ]);
};

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./home/home.module').then((m) => m.HomeModule),
        canActivateChild: [routingGuard],
      },
      {
        path: '',
        loadChildren: () =>
          import('./auth/auth.module').then((m) => m.AuthModule),
        canActivateChild: [routingGuard],
      },
      {
        path: '',
        loadChildren: () => import('./tos/tos.module').then((m) => m.TosModule),
        canActivateChild: [routingGuard],
      },
      ...mergeRoutes(
        [SpanishRoutes, EnglishRoutes, FrenchRoutes, PortugueseRoutes],
        'Contact',
        ContactComponent,
        [routingGuard]
      ),
      ...mergeRoutes(
        [SpanishRoutes, EnglishRoutes, FrenchRoutes, PortugueseRoutes],
        'Platform',
        PlatformComponent,
        [routingGuard]
      ),
    ],
  },

  {
    path: '**',
    component: ErrorComponent,
    canActivate: [routingGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledNonBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
